import React, { useState } from 'react';
import './CompanySelect.css';

function CompanySelect({ onSelect }) {
  // Mock data - replace with real API call
  const companies = [
    { id: 1, name: 'Google', logo: '🏢' },
    { id: 2, name: 'Microsoft', logo: '🏢' },
    { id: 3, name: 'Amazon', logo: '🏢' },
    { id: 4, name: 'Meta', logo: '🏢' },
    { id: 5, name: 'Apple', logo: '🏢' },
  ];

  const [searchTerm, setSearchTerm] = useState('');

  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="company-select">
      <h2>Select a Company</h2>
      <div className="search-box">
        <input
          type="text"
          placeholder="Search companies..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="companies-grid">
        {filteredCompanies.map(company => (
          <div
            key={company.id}
            className="company-card"
            onClick={() => onSelect(company)}
          >
            <div className="company-logo">{company.logo}</div>
            <h3>{company.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CompanySelect; 